module.exports = __webpack_public_path__ + "img/playstore.a87276ad.svg";